<div class="h-100 overflow-auto">
    @if (selectedTab) {
        <div class="container-sm-fluid pt-3 px-sm-4">
            <dx-tabs
                keyExpr="type"
                [items]="tabs"
                [selectedItemKeys]="[selectedTab.type]"
                [showNavButtons]="false"
                stylingMode="primary"
                class="mb-2"
                (onItemClick)="onTabClick($event.itemData)"
            ></dx-tabs>
        </div>

        <div class="container-fluid px-4 pb-4">
            <div class="card border-0 shadow-sm mb-4">
                <div class="card-body d-sm-flex justify-content-between align-items-center">
                    <h4 class="mb-0 text-secondary">Dashboard</h4>
                    <dx-date-range-box
                        [multiView]="false"
                        [showClearButton]="true"
                        [(value)]="dateRange"
                        stylingMode="filled"
                        class="mt-3 mt-sm-0"
                        [labelMode]="'hidden'"
                    ></dx-date-range-box>
                </div>
            </div>

            @switch (selectedTab.type) {
                @case (TabType.Volumes) {
                    <app-dashboard-volumes [from]="dateRange[0]" [to]="dateRange[1]"></app-dashboard-volumes>
                }
                @case (TabType.OurTeam) {
                    <app-dashboard-our-team [from]="dateRange[0]" [to]="dateRange[1]"></app-dashboard-our-team>
                }
                @case (TabType.OurYard) {
                    <app-dashboard-our-yard [from]="dateRange[0]" [to]="dateRange[1]"></app-dashboard-our-yard>
                }
                @case (TabType.Inbound) {
                    <app-dashboard-inbound [from]="dateRange[0]" [to]="dateRange[1]"></app-dashboard-inbound>
                }
                @case (TabType.Inventory) {
                    <app-dashboard-inventory [from]="dateRange[0]" [to]="dateRange[1]"></app-dashboard-inventory>
                }
                @case (TabType.Outbound) {
                    <app-dashboard-outbound [from]="dateRange[0]" [to]="dateRange[1]"></app-dashboard-outbound>
                }
            }
        </div>
    }
</div>
